import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function UserAccount(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "UserAccount", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.177 24.017a9.243 9.243 0 1 0 0-18.487 9.243 9.243 0 0 0 0 18.487Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23 17h-4.502c-.378 0-.62.429-.434.775a6.793 6.793 0 0 0 1.871 2.189 5.05 5.05 0 0 0 6.13 0 6.792 6.792 0 0 0 1.87-2.189c.187-.346-.055-.775-.433-.775H23Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38.302 39.142C37.781 31.183 31 24.857 22.757 24.857S7.733 31.183 7.211 39.142h31.091Z",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
UserAccount.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "UserAccount"
};
validateTidalLicense();
export {
  UserAccount
};
//# sourceMappingURL=UserAccount.js.map
